module.exports = __webpack_public_path__ + "static/img/16.cd664a85.jpg";